import { Dialog } from '@progress/kendo-react-dialogs';
import { Success } from 'app/components/Notifications';

import { AccessConfiguration } from 'app/components/access-sharing';
import { CurrentUserAccessCard } from 'app/components/access-sharing/cards';
import { SharedUserAccess } from 'app/components/access-sharing/cards/SharedUserAccessCard/types';
import { SubmitButton } from 'app/components/form-fields';
import { BackActionDialogContentLayout } from 'app/components/layouts';
import useClickOutside from 'app/hooks/useClickOutside';
import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IAccessSharingPeriodType,
  IAccessSharingPermissionType,
} from 'types/IAccessSharingUser';
import './ChangeUserFleetPermissionsDialog.less';
import { useNotificationsContext } from 'context';

interface Props {
  fleet: any;
  userAccess: SharedUserAccess;
  onClose: () => void;
}

export default function ChangeUserFleetPermissionsDialog({
  fleet,
  userAccess,
  onClose,
}: Props) {
  const { t } = useTranslation();
  // TODO needs to be replaces with useTryMutate when API is ready
  const { addNotification } = useNotificationsContext();

  // Note: there's a point in creating a wrapper around the Dialog and adding an onClickOutside prop
  useClickOutside(onClose);

  const [permission, setPermission] = useState(
    IAccessSharingPermissionType.Viewer,
  );
  const [period, setPeriod] = useState(IAccessSharingPeriodType.Continuous);

  // TODO for testing purposes. Need to be refactored when API is ready
  const initialStartDate = userAccess.startTime
    ? new Date(userAccess.startTime)
    : null;
  const initialEndDate = userAccess.endTime
    ? new Date(userAccess.endTime)
    : null;

  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);

  const { firstName, lastName, email, role } = userAccess;

  return (
    <Dialog className="modal-container">
      <BackActionDialogContentLayout
        className="change-user-fleet-permissions-dialog"
        onBack={onClose}
      >
        <h2 className="change-user-fleet-permissions-dialog__title">
          {t('access_sharing.machine_details.change_users_permissions')}
        </h2>

        <div className="change-user-fleet-permissions-dialog__model">
          <span className="change-user-fleet-permissions-dialog__model-label">
            {t('label_name')}
          </span>
          {fleet.name}
        </div>

        <CurrentUserAccessCard
          name={`${firstName} ${lastName}`}
          email={email}
          role={role}
          className="change-user-fleet-permissions-dialog__current-user-access-card"
        />

        <AccessConfiguration
          initialPermission={permission}
          period={period}
          startDate={startDate}
          endDate={endDate}
          onChangePermission={setPermission}
          onChangePeriod={setPeriod}
          onChangeStartDate={setStartDate}
          onChangeEndDate={setEndDate}
        />

        <SubmitButton
          onClick={() => {
            addNotification(
              <Success
                text={t('access_sharing.snackbars.user_permissions_updated')}
              />,
            );
            onClose();
          }}
        >
          {t('save')}
        </SubmitButton>
      </BackActionDialogContentLayout>
    </Dialog>
  );
}
